import RadioButtonField from "../../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import MilitaryBranch from "./MilitaryBranch"
import CalendarField from "../../../Utils/CalendarField"
import { getFormErrorMessage } from "../../../Utils/formikAux"
import EditorField from "../../../Utils/EditorField"
const MilitaryExperience = ({ formik }) => {
  const cleanValues = () => {
    formik.setFieldValue(
      careerProfileLabels.militaryExperience.militaryExperience_2.value,
      ""
    )
    formik.setFieldValue(
      careerProfileLabels.militaryExperience.militaryExperience_3.value,
      ""
    )
    formik.setFieldValue(
      careerProfileLabels.militaryExperience.militaryExperience_4.value,
      ""
    )
    formik.setFieldValue(
      careerProfileLabels.militaryExperience.militaryExperience_5.value,
      ""
    )
    formik.setFieldValue(
      careerProfileLabels.militaryExperience.militaryExperience_6.value,
      ""
    )
  }
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={
            careerProfileLabels.militaryExperience.militaryExperience_1.label
          }
          value={formik.values.military_1}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.militaryExperience.militaryExperience_1.value
          }
          callback={(value) => {
            if (value !== "Yes") {
              cleanValues()
            }
          }}
        />
      </div>
      {formik.values.military_1 === "Yes" && (
        <>
          <MilitaryBranch
            label={
              careerProfileLabels.militaryExperience.militaryExperience_2.label
            }
            setValue={formik.setFieldValue}
            value={formik.values.military_2}
            valueName={
              careerProfileLabels.militaryExperience.militaryExperience_2.value
            }
          />
          <div
            style={{ display: "flex", justifyContent: "start", gap: "15px" }}
          >
            <CalendarField
              label={
                careerProfileLabels.militaryExperience.militaryExperience_3
                  .label
              }
              value={formik.values.military_3}
              setValue={formik.setFieldValue}
              valueName={
                careerProfileLabels.militaryExperience.militaryExperience_3
                  .value
              }
              error={getFormErrorMessage(
                careerProfileLabels.militaryExperience.militaryExperience_3
                  .value,
                formik
              )}
              size={"50"}
              showErrorMessage
            />
            <CalendarField
              label={
                careerProfileLabels.militaryExperience.militaryExperience_4
                  .label
              }
              value={formik.values.military_4}
              setValue={formik.setFieldValue}
              valueName={
                careerProfileLabels.militaryExperience.militaryExperience_4
                  .value
              }
              error={getFormErrorMessage(
                careerProfileLabels.militaryExperience.militaryExperience_3
                  .value,
                formik
              )}
              size={"50"}
              showErrorMessage
              subText={"(If applicable)"}
            />
          </div>
          <EditorField
            label={
              careerProfileLabels.militaryExperience.militaryExperience_5.label
            }
            onTextChange={formik.setFieldValue}
            value={formik.values.military_5}
            valueName={
              careerProfileLabels.militaryExperience.militaryExperience_5.value
            }
          />
          <EditorField
            label={
              careerProfileLabels.militaryExperience.militaryExperience_6.label
            }
            onTextChange={formik.setFieldValue}
            value={formik.values.military_6}
            valueName={
              careerProfileLabels.militaryExperience.militaryExperience_6.value
            }
          />
        </>
      )}
    </>
  )
}
export default MilitaryExperience
